import { networkService } from "./network-service";


class WalletService {
    async getAccountBalance (account : string) {
        return await window.ethereum.request<number>({method: 'eth_getBalance', params: [account, 'latest']})
    };
}

export const walletService = new WalletService();